import React from 'react';

const SettingsTab = ({ name, active, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 md:px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap flex-shrink-0 ${
        active 
          ? 'bg-indigo-100 text-indigo-800' 
          : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
      }`}
    >
      {name}
    </button>
  );
};

export default SettingsTab;